import React from 'react';
import { FaGithub, FaLinkedin, FaFacebookSquare } from 'react-icons/fa';
import Button from '../Button';
// import { useHistory } from 'react-router';

const About = () => {
    // react-router hooks
    // const history = useHistory();

    return (
        <section className='px-3 pt-10 md:p-5 h-screen'>
            <h1 className='text-3xl font-bold my-3 text-gray-800'>About me</h1>
            < div className='lg:grid lg:grid-cols-4 lg:gap-2 mt-5' >
                <div className='lg:col-span-1'>
                    <img className='w-48 rounded' src='https://i.ibb.co/hxNLG5c/sindabad.jpg' alt="sindabad" />
                </div>
                <div className='lg:col-span-3 mr-5'>
                    <h2 className='text-2xl text-gray-800 mb-2 font-bold mt-3 lg:mt-0'>I am a Front End Developer</h2>
                    <p className='mb-2 pb-2 border-b border-gray-800 leading-7 text-justify'>I am specialized in developing Single Page Application (SPA) using React. I have been working with React about a year. I can convert your design into working web application. I have developed several portfolio projects to demonstarate my skills.</p>
                    <div>
                        <div className='md:flex md:justify-between mr-5 my-4'>
                            <div>
                                <h6 className='text-gray-500'>Name: <span className='text-gray-800'>Md. Sindabad</span></h6>
                                <h6 className='text-gray-500'>From: <span className='text-gray-800'>Dhaka, Bangladesh</span></h6>
                            </div>
                            <div>
                                <h6 className='text-gray-500'>Email: <span className='text-gray-800'>pavel.sindabad@gmail.com</span></h6>
                            </div>
                        </div>
                        <Button className='my-3' name='download resume' link='https://drive.google.com/file/d/1mLNVv5NJh0ogp7A1Ild5-TItDz5kZPOG/view?usp=sharing' />
                        <div className='mt-4 flex text-3xl'>
                            <a className='mx-1 transition hover:text-green-600' href='https://github.com/mdSindabad' target='_blank'>
                                <FaGithub />
                            </a>
                            <a className='mx-1 transition hover:text-green-600' href='https://www.linkedin.com/in/md-sindabad-36412265' target='_blank'>
                                <FaLinkedin />
                            </a>
                            <a className='mx-1 transition hover:text-green-600' href='https://www.facebook.com/sindabad.pavel/' target='_blank'>
                                <FaFacebookSquare />
                            </a>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    )
}

export default About;
